import { __makeTemplateObject } from "tslib";
import styled from "../../redoc-lib/src/styled-components";
export var Trigger = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  align-items: center;\n"])));
var templateObject_1;